<template>
  <v-subheader class="font-weight-regular">
    <span class="error--text" v-if="hasErrors">
      Please checkout errors to resubmit.
    </span>
    <span class="info--text" v-else>
      You may resubmit your data.
    </span>
  </v-subheader>
</template>

<script>
  export default {
    props: {
      hasErrors: Boolean,
    },
    data() {
      return {
        dialog: false,
      }
    },
    methods: {
      close() {
        this.dialog = false
      },
    },
  }
</script>

<style>
  .log-chip>.v-chip__content {
    padding: 0 4px;
    padding-bottom: 2px;
  }
</style>
<style scoped>
  .key {
    display: inline-block;
    font-weight: 500;
    min-width: 100px;
  }
</style>